// src/router/index.js
import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus' // 或其他UI库的消息提示

// 导入需要路由的组件
import Home from '@/views/home/HomeIndex.vue'
import Login from '@/views/login/UserLogin.vue'
import knowledge from '@/views/knowledge/KnowledgePage.vue'
import newDatabaseInfo from '@/views/databaseinfo/NewDatabaseInfo.vue'
import WeiXinCode from '@/views/databaseinfo/WeiXinCode.vue'
import orderPage from '@/views/components/OrderPage.vue'
import orderCompletPage from '@/views/components/OrderCompletPage.vue'
import databaseDetails from '@/views/components/DatabaseDetails.vue'
import ifreamIndex from '@/views/Ifream/IfreamIndex.vue'
import iframesy from '@/views/databaseinfo/Iframesy.vue'
import solution from '@/views/components/AppSolution.vue'
import agency from '@/views/components/Appagency.vue'
import cooperation from '@/views/components/AppCooperation.vue'
import copyright from '@/views/components/AppCopyright.vue'
import hydtinfolist from '@/views/components/hydtinfolist.vue'
import NewBannerindex from '@/views/components/NewBannerindex.vue'
import NewLicationArea from '@/views/components/NewLicationArea.vue'
import LocalCharaDatabase from '@/views/components/LocalCharaDatabase.vue'
import PurchasedKnowledge from '@/views/components/PurchasedKnowledge.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/knowledge',
    name: 'knowledge',
    component: knowledge,
    meta: { requiresAuth: false }
  },
  // {
  //   path: '/databaseinfo',
  //   name: 'databaseinfo',
  //   component: databaseinfo,
  //   meta: { requiresAuth: false }
  // },
  {
    path: '/newDatabaseInfo',
    name: 'newDatabaseInfo',
    component: newDatabaseInfo,
    meta: { requiresAuth: false }
  },
  {
    path: '/orderPage',
    name: 'orderPage',
    component: orderPage,
    meta: { requiresAuth: false }
  }, {
    path: '/orderCompletPage',
    name: 'orderCompletPage',
    component: orderCompletPage,
    meta: { requiresAuth: false }
  }, {
    path: '/databaseDetails',
    name: 'databaseDetails',
    component: databaseDetails,
    meta: { requiresAuth: false }
  }
  , {
    path: '/ifreamIndex',
    name: 'ifreamIndex',
    component: ifreamIndex,
    meta: { requiresAuth: false }
  }
  , {
    path: '/solution',
    name: 'solution',
    component: solution,
    meta: { requiresAuth: false }
  }
  , {
    path: '/agency',
    name: 'agency',
    component: agency,
    meta: { requiresAuth: false }
  }, {
    path: '/cooperation',
    name: 'cooperation',
    component: cooperation,
    meta: { requiresAuth: false }
  }, {
    path: '/copyright',
    name: 'copyright',
    component: copyright,
    meta: { requiresAuth: false }
  }, {
    path: '/iframesy',
    name: 'iframesy',
    component: iframesy,
    meta: { requiresAuth: false }
  },
   {
    path: '/hydtinfolist',
    name: 'hydtinfolist',
    component: hydtinfolist,
    meta: { requiresAuth: false }
  },
   {
    path: '/WeiXinCode',
    name: 'WeiXinCode',
    component: WeiXinCode,
    meta: { requiresAuth: false }
  }, {
    path: '/NewBannerindex',
    name: 'NewBannerindex',
    component: NewBannerindex,
    meta: { requiresAuth: false }
  }, {
    path: '/NewLicationArea',
    name: 'NewLicationArea',
    component: NewLicationArea,
    meta: { requiresAuth: false }
  },{
    path: '/LocalCharaDatabase',
    name: 'LocalCharaDatabase',
    component: LocalCharaDatabase,
    meta: { requiresAuth: false }
  },{
    path: '/PurchasedKnowledge',
    name: 'PurchasedKnowledge',
    component: PurchasedKnowledge,
    meta: { requiresAuth: false }
  },

  
  
]

// 创建路由实例
const router = createRouter({
  history:  createWebHistory(), // 修改这里
  routes
})

/**
 * 检查token是否有效
 * @param {string} token 
 * @returns {boolean}
 */
function isTokenValid(token) {
  if (!token) return false

  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    if (payload.exp) {
      return Date.now() < payload.exp * 1000
    }
    return true
  } catch (e) {
    return false
  }
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (!to.meta.requiresAuth) {
    return next()
  }
  const token = JSON.parse(Cookie.get('token')) || ''
  // 1. 检查token是否存在
  if (!token) {
    ElMessage.warning('请先登录')
    console.log('登录失效');
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
  // 2. 检查token是否有效
  if (!isTokenValid(token)) {
    ElMessage.warning('登录已过期，请重新登录')
    Cookie.remove('userInfo');
    Cookie.remove('token');
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }

  // 3. 正常放行
  next()
})

export default router